<template>
  <!-- // 项目续约统计 -->
  <div class="app-container">
    <div class="mycontainer" style="margin-bottom: 10px">
      <el-form ref="queryForm" :model="listQuery" :inline="true">
        <!-- <div class="back" @click="$router.go(-1)">
          <div><i class="el-icon-back"></i></div>
        </div> -->
        <el-form-item
          label="所属部门"
          style="margin-left: 0px"
          prop="bmmc"
          label-width="80px"
        >
          <el-select
            ref="bmmc"
            v-model="listQuery.bmbh"
            placeholder="全部"
            clearable
            filterable
            size="small"
            class="filter-item"
            style="width: 200px"
          >
            <el-option
              v-for="item in zxlc.bmList"
              :key="item.bmbh"
              :label="item.bmmc"
              :value="item.bmbh"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="项目状态" prop="name" label-width="80px">
          <el-select
            ref="name"
            v-model="listQuery.xmzt"
            placeholder="全部"
            clearable
            filterable
            size="small"
            class="filter-item"
            style="width: 200px"
            multiple
            collapse-tags
          >
            <el-option
              v-for="item in zxlc.xmztList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="合同到期日期类型" prop="name">
          <el-select
            ref="name"
            v-model="listQuery.dateType"
            placeholder="全部"
            filterable
            size="small"
            class="filter-item"
            style="width: 200px"
          >
            <el-option
              v-for="item in dateTypeList"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="年份" prop="name" label-width="80px">
          <el-select
            ref="name"
            v-model="listQuery.year"
            placeholder="全部"
            filterable
            size="small"
            class="filter-item"
            style="width: 200px"
          >
            <el-option
              v-for="item in yearList"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="季度"
          prop="name"
          v-if="listQuery.dateType == '按季'"
          label-width="80px"
        >
          <el-select
            ref="name"
            v-model="listQuery.quarter"
            placeholder="全部"
            filterable
            size="small"
            class="filter-item"
            style="width: 200px"
          >
            <el-option
              v-for="item in quarterList"
              :key="item.key"
              :label="item.label"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
        <span style="margin-top: 4px; margin-left: 15px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="getList()"
            >搜 索</el-button
          >
        </span>
        <span style="margin-top: 4px; margin-left: 15px; display: inline-block">
          <el-button size="small" @click="reset()">重 置</el-button>
        </span>
      </el-form>
      <div style="margin: 10px 15px">
        <el-button type="primary" size="small" @click="handleToMx()"
          >续约明细</el-button
        >
        <el-button
          type="primary"
          style="margin-left: 15px"
          size="small"
          @click="handlExportList()"
          >导出</el-button
        >
      </div>
    </div>
    <div>
      <div>
        <el-table
          v-loading="listLoading"
          :data="zxlc.xytjList.list"
          fit
          :header-cell-style="tableHeaderColor"
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
          :max-height="height"
        >
          <el-table-column
            label="所属部门"
            prop="bmmc"
            min-width="150px"
            :show-overflow-tooltip="true"
            align="center"
            fixed
          >
            <template slot-scope="scope">
              <div
                @click="handleToMx(scope.row.bmbh)"
                style="text-decoration: underline; cursor: pointer"
              >
                {{ scope.row.bmmc }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="到期项目数"
            prop="htdqxms"
            min-width="140px"
            align="center"
            fixed
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                content="合同终止日期为当年，且项目状态为“项目服务中”“项目完结”的DS项目总数"
                placement="top"
              >
                <div>
                  到期项目数&nbsp;
                  <img src="@/img/tips.png" width="16" alt="" />
                </div>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <div
                v-if="scope.row.htdqxms && scope.row.htdqxms != 0"
                @click="handleToView(scope.row, '合同到期', 3)"
                style="text-decoration: underline; cursor: pointer"
              >
                {{ scope.row.htdqxms }}
              </div>
              <div v-else>{{ scope.row.htdqxms }}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="未续约"
            prop="wxy"
            min-width="140px"
            align="center"
            fixed
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                content="到期项目中续约结果未登记以及续约结果登记为“续约不成功”的项目总数"
                placement="top"
              >
                <div>
                  未续约&nbsp;
                  <img src="@/img/tips.png" width="16" alt="" />
                </div>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <div
                v-if="scope.row.wxy && scope.row.wxy != 0"
                @click="handleToView(scope.row, '未续约', 0)"
                style="text-decoration: underline; cursor: pointer"
              >
                {{ scope.row.wxy ? scope.row.wxy : 0 }}
              </div>
              <div v-else>{{ scope.row.wxy ? scope.row.wxy : 0 }}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="已续约"
            prop="yxy"
            min-width="140px"
            align="center"
            fixed
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                content="到期项目中续约结果登记为“续约成功”的项目总数"
                placement="top"
              >
                <div>
                  已续约&nbsp;
                  <img src="@/img/tips.png" width="16" alt="" />
                </div>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <div
                v-if="scope.row.yxy && scope.row.yxy != 0"
                @click="handleToView(scope.row, '已续约', 1)"
                style="text-decoration: underline; cursor: pointer"
              >
                {{ scope.row.yxy ? scope.row.yxy : 0 }}
              </div>
              <div v-else>{{ scope.row.yxy ? scope.row.yxy : 0 }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="xmxgzp" min-width="155px" align="center">
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                content="到期项目中已完成“项目效果自评”的项目数"
                placement="top"
              >
                <div>
                  完成项目效果自评&nbsp;
                  <img src="@/img/tips.png" width="16" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="cjdghqd" min-width="170px" align="center">
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                content="到期项目中已完成“成绩单规划清单”的项目数"
                placement="top"
              >
                <div>
                  完成成绩单规划清单&nbsp;
                  <img src="@/img/tips.png" width="16" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="cjdylb" min-width="155px" align="center">
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                content="到期项目中已完成“成绩单一览表”的项目数"
                placement="top"
              >
                <div>
                  完成成绩单一览表&nbsp;
                  <img src="@/img/tips.png" width="16" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="ybsrzpg" min-width="170px" align="center">
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                content="到期项目中已完成“一把手认知评估”的项目数"
                placement="top"
              >
                <div>
                  完成一把手认知评估&nbsp;
                  <img src="@/img/tips.png" width="16" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="xyjcgzzxl" min-width="170px" align="center">
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                content="合同期限在1年及以上的到期项目中，已完成项目效果自评、成绩单规划清单、成绩单一览表、一把手认知评估合计数/合同期限1年及以上的项目数*4"
                placement="top"
              >
                <div>
                  续约基础工作执行率&nbsp;
                  <img src="@/img/tips.png" width="16" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="khbf" min-width="140px" align="center">
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                content="到期项目中已完成“客户拜访”的项目数"
                placement="top"
              >
                <div>
                  完成客户拜访&nbsp;
                  <img src="@/img/tips.png" width="16" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="完成策略研讨"
            prop="clyt"
            min-width="140px"
            align="center"
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                content="到期项目中已完成“策略研讨”的项目数"
                placement="top"
              >
                <div>
                  完成策略研讨&nbsp;
                  <img src="@/img/tips.png" width="16" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="完成续约汇报"
            prop="xyhb"
            min-width="140px"
            align="center"
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                content="到期项目中已完成“续约汇报”的项目数"
                placement="top"
              >
                <div>
                  完成续约汇报&nbsp;
                  <img src="@/img/tips.png" width="16" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="续约流程执行率"
            prop="xygzlczxl"
            min-width="140px"
            align="center"
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                content="合同期限在1年及以上的到期项目中，已完成客户拜访、策略研讨、续约汇报合计数/合同期限1年及以上的项目数*3"
                placement="top"
              >
                <div>
                  续约流程执行率&nbsp;
                  <img src="@/img/tips.png" width="16" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="整体续约完成率"
            prop="ztxywcl"
            min-width="140px"
            align="center"
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                content="整体续约完成率 = （DS模式续约+降级续约项目数）/到期DS项目数"
                placement="top"
              >
                <div>
                  整体续约完成率&nbsp;
                  <img src="@/img/tips.png" width="16" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="DS模式续约完成率"
            prop="dsxywcl"
            min-width="160px"
            align="center"
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                content="DS模式续约完成率 = DS模式续约项目数/到期DS项目数"
                placement="top"
              >
                <div>
                  DS模式续约完成率&nbsp;
                  <img src="@/img/tips.png" width="16" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>

          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
        <pagination
          v-show="zxlc.xytjList.total > 0"
          :total="zxlc.xytjList.total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.pageSize"
          @pagination="getList"
        />
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="dialogTitle"
      :visible.sync="viewDialog"
      width="90%"
      v-if="viewDialog"
      id="bbzqmx"
    >
      <Bbzqmx
        ref="view"
        @giveFather="getSon"
        :mxParams="mxParams"
        :params="params"
      ></Bbzqmx>
      <div slot="footer" class="dialog-footer">
        <el-button @click="viewDialog = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import Pagination from "@/components/Pagination";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";
import Bbzqmx from "./bbzqmx.vue";
import { exportXytjList } from "@/api/zxlc";
import {
  formatMomentDate,
  getCurrentYear,
  getCurrentQuarter,
  addExportFileDate,
} from "@/utils/utils";

export default {
  // 列表分页
  name: "xmxyList",
  components: { Treeselect, Pagination, Bbzqmx },
  computed: {
    ...mapGetters(["deptUser", "user", "zxlc"]),
  },
  data: () => {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },

      mxParams: {},
      height: 800,
      dialogTitle: null,
      listQuery: {
        bmbh: null,
        xmzt: ["1", "2"],
        page: 1,
        pageSize: 50,
        dateType: "按年",
        year: getCurrentYear(),
        quarter: getCurrentQuarter(),
        qssj: "",
        jssj: "",
      },
      listLoading: false,
      total: 0,

      applyDialog: false,
      viewDialog: false,
      editDialog: false,
      mxParams: {},
      params: {},
      dateTypeList: ["按年", "按季"],
      yearList: [],
      quarterList: [
        {
          label: "一季度",
          value: "0101-0331",
          key: "1",
        },
        {
          label: "二季度",
          value: "0401-0630",
          key: "2",
        },
        {
          label: "三季度",
          value: "0701-0930",
          key: "3",
        },
        {
          label: "四季度",
          value: "1001-1231",
          key: "4",
        },
      ],
    };
  },

  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    if (this.zxlc.htztList.length == 0) {
      this.$store.dispatch("zxlc/fetchHtztListAction", {
        dictType: "xmzt",
        type: 2,
      });
    }

    if (this.zxlc.xmztList.length == 0) {
      this.$store.dispatch("zxlc/fetchXmztListAction", {
        dictType: "xmgl_xmzt",
        type: 2,
      });
    }
    if (this.zxlc.bmList.length == 0) {
      this.$store.dispatch("zxlc/fetchBmListAction", { type: 2, range: 1 });
    }
    // if (localStorage.getItem("zxlc_xmxy_tj_xmzt")) {
    //   this.listQuery.xmzt = localStorage.getItem("zxlc_xmxy_tj_xmzt");
    // }
    // if (this.user.bntqxzt == 2) {
    //   this.listQuery.bmbh = this.user.bmbh;
    // }
    let tempList = [];
    for (let y = getCurrentYear() - 3; y < getCurrentYear() + 2; y++) {
      tempList.push(y + "");
    }
    this.yearList = tempList;
    if (localStorage.getItem("zxlc_xmxy_tj_year")) {
      this.listQuery.year = localStorage.getItem("zxlc_xmxy_tj_year");
      localStorage.removeItem("zxlc_xmxy_tj_year");
    }
    this.getList();
  },
  mounted() {
    this.startWatching();
  },
  methods: {
    reset() {
      this.listQuery = {
        ...this.listQuery,
        ...{
          bmbh: null,
          xmzt: [],
          dateType: "按年",
          year: getCurrentYear(),
          quarter: "",
        },
      };
    },
    getList() {
      this.listLoading = true;
      const { bmbh, xmzt, dateType, year, quarter, page, pageSize } =
        this.listQuery;
      let params = {
        bmbh,
        xmzt: xmzt.join(","),
        page,
        pageSize,
      };
      if (dateType == "按年") {
        params.year = year;
      } else {
        for (let i of this.quarterList)
          if (quarter == i.key) {
            params.qssj = year + i.value.substring(0, 4);
            params.jssj = year + i.value.substring(5, 9);
            break;
          }
      }
      this.$store.dispatch("zxlc/fetchXytjListAction", params).then((res) => {
        if (res.code == 0) {
          this.listLoading = false;
          const docH = document.documentElement.clientHeight;
          const mycontainerH =
            document.querySelector(".mycontainer").clientHeight;
          this.height = docH - mycontainerH - 75;
        }
      });
    },

    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },

    handleShowAdvice(e) {
      this.$refs.audit.handleShowAdvice(e);
    },
    handlExportList() {
      const { bmbh, xmzt, dateType, year, quarter } = this.listQuery;
      let params = {
        bmbh,
        xmzt: xmzt.join(","),
      };
      if (dateType == "按年") {
        params.year = year;
      } else {
        for (let i of this.quarterList)
          if (quarter == i.key) {
            params.qssj = year + i.value.substring(0, 4);
            params.jssj = year + i.value.substring(5, 9);
            break;
          }
      }
      exportXytjList({
        ...params,
      }).then((res) => {
        if (res.code === 0) {
          const fileName = addExportFileDate(
            res.msg.substr(res.msg.indexOf("_") + 1, res.msg.length)
          );
          const filePath = res.msg;
          const url =
            window.g.apiUrl +
            "system/downloadFile?fileName=" +
            fileName +
            "&filePath=" +
            filePath; // 组装a标签
          const elink = document.createElement("a"); // 设置下载文件名
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = url;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    handleToView(row, colTitle, status) {
      this.dialogTitle = row.bmmc + colTitle + "项目";
      this.mxParams = row;

      const { xmzt, dateType, year, quarter  } = this.listQuery;

      const params = {
        dateType,
        year,
        xmzt: xmzt.join(","),
        bmbh: row.bmbh,
        status,
        page : 1,
        pageSize : 10,
      };
      this.params = params;
      if (dateType == "按年") {
        params.year = year;
      } else {
        for (let i of this.quarterList)
          if (quarter == i.key) {
            params.qssj = year + i.value.substring(0, 4);
            params.jssj = year + i.value.substring(5, 9);
            break;
          }
      }

      this.$store.dispatch("zxlc/fetchBbmxListAction", {
        ...params,
      });
      this.viewDialog = true;
    },

    getSon(temp) {
      this.applyDialog = temp;
      this.getList();
    },
    handleToMx(bmbh) {
      //测试生产使用
      if (bmbh !== undefined) {
        localStorage.setItem("zxlc_xmxy_mx_bmbh", bmbh);
      } else {
        localStorage.removeItem("zxlc_xmxy_mx_bmbh");
      }
      var dataUrl = `/menuRedirect?systemType=tmis-pmp&redireType=tmis&menuType=82`;
      var menuName = "续约明细";
      var dataIndex = Math.round(Math.random() * 10000);
      var data1 = { dataIndex, dataUrl, menuName };
      window.parent.postMessage(data1, "*");
    },
    startWatching() {
      setInterval(() => {
        const currentYear = localStorage.getItem("zxlc_xmxy_tj_year");
        if (currentYear) {
          location.reload();
        }
      }, 1000);
    },
  },
};
</script>
  <style lang="less" scoped>
.flex-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5%;
}
.choice-box {
  border: 1px solid;
  border-color: #cccc;
  display: auto;
}
.app-container {
  padding: 10px;
  .dialog-footer {
    text-align: right;
    button {
      margin-left: 30px;
    }
  }
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
}
.back {
  display: inline-block;
  background-color: #ffba01;
  height: 32px;
  width: 48px;
  line-height: 32px;
  text-align: center;
  color: #fff;
  border-radius: 5px;
  cursor: pointer;
}
.mycontainer .el-form-item {
  margin-bottom: 5px;
}
.filter-container {
  background-color: #fff;
  padding: 0;
}
.filter-container .filter-item {
  margin-bottom: 0;
}
.search-container {
  border: 0;
}
.btn-container {
  padding-top: 0px;
  margin-top: 10px;
  background-color: #f2f2f2;
  border-top: #e2e2e2 1px solid;
  border-left: #e2e2e2 1px solid;
  border-right: #e2e2e2 1px solid;
}
.dialog-footer {
  text-align: center;
}
.dialog-header {
  background-color: #f2f2f2;
  margin: 5px 5px;
}
.btn {
  display: block;
  margin: 10px 10px;
  width: 120px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.avatar {
  display: block;
  width: 60px;
  margin: 10px 10px;
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-input__inner {
  width: 100%;
}

.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.flex-item1 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.flex-item2 {
  width: 80px;
  height: 70px;
}
.flex-item3 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.el-table__row > td {
  border: none;
}
.el-table::before {
  height: 0px;
}
.el-table th.is-leaf,
.el-table td {
  border-bottom: 0px;
}

::v-deep .el-dialog {
  width: 64%;
}
::v-deep .el-transfer-panel {
  width: 263px;
}
.pagination-container {
  border: none;
}
::v-deep #save-form .el-form-item__label {
  width: 150px !important;
}
::v-deep #save-form .el-form-item__content {
  margin-left: 150px !important;
}
::v-deep #save-form .el-select {
  width: 100% !important;
}
::v-deep #bbzqmx .el-dialog__body {
  padding-top: 0;
  padding-bottom: 0;
}
#save-form .el-form-item {
  margin-bottom: 20px;
}
.border /deep/ .el-table__row > td {
  /* 去除表格线 */
  border: none;
  padding: 0;
}
</style>

